// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".card--CPHTl {\n  position: relative;\n  padding: 0;\n}", "",{"version":3,"sources":["webpack://./src/gui/Apps/Admin/Pages/CountrySettings/TariffPlanTypes/index.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,UAAU;AACZ","sourcesContent":[".card {\n  position: relative;\n  padding: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": "card--CPHTl"
};
export default ___CSS_LOADER_EXPORT___;
